// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__X85K5","search":"Settings_search__UMkbt","filter":"Settings_filter__o49cV"};